import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';
import SelectAsync from 'react-select/async';

export default class EstateFlow extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            estateId: props.EstateId,
            estateFlowType: props.EstateFlowType,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/estateflow/get", {
            id: this.getCurrentFormId(),
            estateId: this.state.estateId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.quantity)) this.state.data.record.quantity = 0;

        this.httpPost("api/v1/estateflow/save", {
            id: this.state.id,
            estateId: this.state.data.record.estateId,
            estateFlowType: this.state.estateFlowType,

            date: this.convertMomentToDb(this.state.data.record.date),
            quantity: parseFloat(this.state.data.record.quantity),
            description: this.state.data.record.description,
            personId: this.state.data.record.personId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setPerson(e) {
        this.state.data.record.personId = e.value;
        this.state.data.record.personName = e.label;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable">
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات" : "افزودن جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">تاریخ<span className="red">*</span></label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.date = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">شخص</label><span className="red">*</span>
                                            <SelectAsync
                                                defaultValue={this.state.data.record.personId != this.getDefaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب شخص"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1,1)}
                                                onChange={e => this.setPerson(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">تعداد</label><span className="red">*</span>
                                            <input type="text" defaultValue={this.state.data.record.quantity} onChange={e => this.state.data.record.quantity = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxLength="400" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">توضیحات</label><span className="red">*</span>
                                            <textarea defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm" style={{ "height": "120px" }}></textarea>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}